import Gator from 'gator';

Gator(_gg.html).on('click', '.nav-element.-level1.-hassub > a', (event) => {
    event.stopPropagation();
});

Gator(_gg.html).on('click', '.nav-element.-level1.-hassub', function () {
    this.classList.toggle('-listopen');
});
